export const SLOTS_MANAGER_PAGE = () => "/slots-manager";
